module.exports = __webpack_public_path__ + "static/img/grade_8.50fb137.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_8.png
// module id = ZSMZ
// module chunks = 89